module.exports = __webpack_public_path__ + "static/media/fantom-logo.692e5cea.png";